/** Reports infra API — remote fetch, cache, repos y tipos de infra. */

export {
  fetchRemoteBranchCashSummary,
  fetchRemoteBranchCashSessions,
  fetchRemoteListSales,
  fetchRemotePosExceptionSummary,
  fetchRemoteSaleDetail,
  fetchRemoteSalesComparison,
  fetchRemoteSalesDaily,
  fetchRemoteSalesByCashier,
  fetchRemoteSalesSnapshot,
  fetchRemoteSalesTimeBands,
  fetchRemoteBranchSalesByProduct,
  fetchRemoteCashClosuresCount,
  fetchRemoteCashClosuresHistory,
  fetchWithRetry,
  isOnline,
} from './remote-api';
export { REMOTE_FETCH_RETRIES, REMOTE_FETCH_RETRY_DELAY_MS } from './remote-api';

export { getReportsCacheIfFresh, setReportsCache, invalidateReportsCache, reportsCacheKey, withReportsCache } from './infra/reportsRemoteCache';
export { fetchRemoteCashActivity } from './infra/reportsRemoteRepo';
export type { CashActivityItem } from './infra/reportsRemoteCashRepo';

// ─── Purchases report (F3) ───────────────────────────────────────────────────
export { fetchRemotePurchasesSummary, fetchRemoteSupplierPerformance } from './infra/reportsRemotePurchasesRepo';
